import { createAction } from 'redux-actions'

/**
 * Sets page type without any checks. Should not be freely used, meant only for
 * history changes updates
 * @function
 * @param {PageType} pageType
 */
export const enforcePageType = createAction(
  'PAGE/ENFORCE_TYPE',
  (pageType) => pageType
)
